import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { DataService } from '../../../core/service/base/data.service';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { InvoiceRowGroup } from '../../model/invoice-row-group';

@Injectable()
export class InvoiceRowGroupService extends DataService<InvoiceRowGroup> {
  constructor(
    private _client: HttpClient,
    private _messageService: MessageService,
    private _progressBar: ProgressBarService,
    @Inject(APP_CONFIG) config: IAppConfig
  ) {
    super(_client, config, _messageService, InvoiceRowGroup, _progressBar, 'invoice-row-group');
  }
}
